import { CohortType } from '@dynamika-shared/types/cohorts';
export const patientCodePattern = (cohort: CohortType | undefined) => {
  if (cohort) {
    return new RegExp(
      '^' +
        cohort.patientCodePattern
          .replace(/%/g, '\\d')
          .replace(/\*/g, '[a-zA-Z]') +
        '$'
    );
  }
};
